export default __webpack_public_path__ + "static/media/bg site 2.a671b981.jpg";